import { type PropsWithChildren, type ReactElement } from 'react'

import { IconCheckCircle, IconInfo } from '@redteclab/icons'

import { IconListItem } from 'base-ui'

type Props = PropsWithChildren<{ isValidationSuccess: boolean }>

export const AuthenticationPasswordRequirementsIndicatorRow = ({
  children,
  isValidationSuccess,
}: Props): ReactElement => {
  return (
    <IconListItem
      className="items-center gap-2"
      icon={
        isValidationSuccess ? (
          <IconCheckCircle className="text-dark-success" />
        ) : (
          <IconInfo className="text-dark-primary-min" />
        )
      }
    >
      <span className="text-dark-primary-max"> {children}</span>
    </IconListItem>
  )
}
